import AwardsListing from './main/awards';
import NewsListing from './main/news';
import CreativeListing from './main/creative';
import OfficesListing from './main/offices';
import CareerOffices from './main/careers';
import SiteSearch from './main/site-search';

jQuery(document).ready(($) => {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
  axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";

  const newsListing = $('#news-listing').get(0);
  if (newsListing) {
    const news = new NewsListing(newsListing);
  }

  const awardsListing = $('#awards-listing').get(0);
  if (awardsListing) {
    const awards = new AwardsListing(awardsListing);
  }
  const creativeListing = $('#creative-listing').get(0);
  if (creativeListing) {
    const creative = new CreativeListing(creativeListing);
  }

  const officesListing = $('#offices-list').get(0);
  if (officesListing) {
    OfficesListing($);
  }

  const siteSearch = $('.gheader__navbar__search').get(0);
  if (siteSearch) {
    const search = new SiteSearch(siteSearch);
  }

  const careersListing = $('.js-career-offices-list').get(0);
  if (careersListing) {
    const careers = new CareerOffices(careersListing);
  }
});
